import { cn as e } from "../shared/utils.js";
import { forwardRef as t } from "react";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { mergeProps as i } from "@base-ui/react/merge-props";
import { useRender as a } from "@base-ui/react/use-render";
import { Drawer as o } from "@base-ui/react/drawer";
//#region src/drawer/index.tsx
var s = {
	bottom: "down",
	left: "left",
	right: "right"
}, c = ({ side: e = "bottom", ...t }) => /* @__PURE__ */ n(o.Root, {
	swipeDirection: s[e],
	...t
}), l = t((e, t) => /* @__PURE__ */ n(o.Portal, {
	ref: t,
	...e
})), u = t((e, t) => /* @__PURE__ */ n(o.Trigger, {
	ref: t,
	"data-slot": "drawer-trigger",
	"data-testid": "drawer-trigger",
	...e
})), d = t((e, t) => /* @__PURE__ */ n(o.Close, {
	ref: t,
	"data-slot": "drawer-close",
	"data-testid": "drawer-close",
	...e
})), f = t(({ className: t, ...r }, i) => /* @__PURE__ */ n(o.Backdrop, {
	forceRender: !0,
	ref: i,
	className: e("bg-system-secondary-950/25 fixed inset-0 z-50 min-h-dvh backdrop-blur-sm", "opacity-[calc(1-var(--drawer-swipe-progress,0))]", "transition-opacity duration-450 ease-[cubic-bezier(0.32,0.72,0,1)]", "data-ending-style:opacity-0 data-starting-style:opacity-0", "data-swiping:duration-0", "data-ending-style:duration-[calc(var(--drawer-swipe-strength,1)*400ms)]", "supports-[-webkit-touch-callout:none]:absolute", t),
	"data-slot": "drawer-backdrop",
	"data-testid": "drawer-backdrop",
	...r
})), p = t(({ className: t, ...r }, i) => /* @__PURE__ */ n(o.Viewport, {
	ref: i,
	className: e("fixed inset-0 z-50 flex", "has-[>[data-swipe-direction=down]]:items-end", "has-[>[data-swipe-direction=down]]:justify-center", "has-[>[data-swipe-direction=right]]:justify-end", t),
	"data-slot": "drawer-viewport",
	"data-testid": "drawer-viewport",
	...r
})), m = t(({ className: t, children: r, render: o, ...s }, c) => {
	let l = {
		className: e("flex w-full shrink-0 items-start justify-center overflow-hidden pt-2.5 pb-1.5", "group-data-[swipe-direction=left]/drawer-popup:hidden group-data-[swipe-direction=right]/drawer-popup:hidden", "transition-opacity duration-300 ease-[cubic-bezier(0.45,1.005,0,1.005)] group-data-nested-drawer-open/drawer-popup:opacity-0 group-data-nested-drawer-swiping/drawer-popup:opacity-100", t),
		"data-slot": "drawer-handle",
		"data-testid": "drawer-handle",
		ref: c,
		children: r ?? /* @__PURE__ */ n("span", {
			"aria-hidden": !0,
			className: "bg-border-300 h-1 w-10 shrink-0 rounded-[2px]",
			"data-slot": "drawer-handle-bar",
			"data-testid": "drawer-handle-bar"
		})
	};
	return a({
		defaultTagName: "div",
		props: i(l, s),
		render: o
	});
}), h = t(({ className: t, children: i, showHandle: a = !0, backdropProps: s, portalProps: c, viewportProps: u, ...d }, h) => /* @__PURE__ */ r(l, {
	...c,
	children: [/* @__PURE__ */ n(f, { ...s }), /* @__PURE__ */ n(p, {
		...u,
		children: /* @__PURE__ */ r(o.Popup, {
			ref: h,
			className: e("group/drawer-popup bg-bg-primary text-text-primary relative flex max-h-[90dvh] w-full min-w-0 flex-col overflow-hidden rounded-t-[20px] outline-none", "touch-auto will-change-transform", "[--bleed:3rem] [--peek:1rem]", "[--stack-progress:clamp(0,var(--drawer-swipe-progress,0),1)]", "[--stack-step:0.05]", "[--stack-peek-offset:max(0px,calc((var(--nested-drawers,0)-var(--stack-progress))*var(--peek)))]", "[--stack-scale-base:max(0,calc(1-(var(--nested-drawers,0)*var(--stack-step))))]", "[--stack-scale:calc(var(--stack-scale-base)+(var(--stack-step)*var(--stack-progress)))]", "[--stack-shrink:calc(1-var(--stack-scale))]", "[--stack-height:max(0px,calc(var(--drawer-frontmost-height,var(--drawer-height,0px))-var(--bleed)))]", "[--translate-y:calc(var(--drawer-swipe-movement-y,0px)-var(--stack-peek-offset)-(var(--stack-shrink)*var(--stack-height)))]", "origin-[50%_calc(100%-var(--bleed))]", "transform-[translateY(calc(var(--drawer-snap-point-offset,0px)+var(--translate-y)))_scale(var(--stack-scale))]", "h-(--drawer-height,auto)", "transition-[transform,height] duration-450 ease-[cubic-bezier(0.32,0.72,0,1)]", "data-nested-drawer-swiping:duration-0 data-swiping:duration-0 data-swiping:select-none", "data-starting-style:transform-[translateY(calc(100%+2px))_scale(1)]", "data-ending-style:transform-[translateY(calc(100%+2px))_scale(1)]", "data-ending-style:duration-[calc(var(--drawer-swipe-strength,1)*400ms)]", "data-nested-drawer-open:h-[calc(var(--stack-height)+var(--bleed))]", "after:pointer-events-none after:absolute after:inset-0 after:bg-transparent after:transition-[background-color] after:duration-450 after:ease-[cubic-bezier(0.32,0.72,0,1)] after:content-['']", "data-nested-drawer-open:after:bg-black/5", "data-[swipe-direction=left]:h-full data-[swipe-direction=left]:max-h-full data-[swipe-direction=left]:rounded-none", "data-[swipe-direction=left]:transform-[translateX(var(--drawer-swipe-movement-x))] data-[swipe-direction=left]:transition-transform", "data-[swipe-direction=left]:data-ending-style:transform-[translateX(-100%)] data-[swipe-direction=left]:data-starting-style:transform-[translateX(-100%)]", "data-[swipe-direction=right]:ms-auto data-[swipe-direction=right]:h-full data-[swipe-direction=right]:max-h-full data-[swipe-direction=right]:rounded-none", "data-[swipe-direction=right]:transform-[translateX(var(--drawer-swipe-movement-x))] data-[swipe-direction=right]:transition-transform", "data-[swipe-direction=right]:data-ending-style:transform-[translateX(100%)] data-[swipe-direction=right]:data-starting-style:transform-[translateX(100%)]", t),
			"data-slot": "drawer-popup",
			"data-testid": "drawer-popup",
			...d,
			children: [a && /* @__PURE__ */ n(m, {}), i]
		})
	})]
})), g = t(({ className: t, ...r }, i) => /* @__PURE__ */ n(o.Content, {
	ref: i,
	className: e("flex min-h-0 w-full shrink flex-col gap-4 overflow-y-auto overscroll-contain p-4 *:shrink-0", "transition-opacity duration-300 ease-[cubic-bezier(0.45,1.005,0,1.005)] group-data-nested-drawer-open/drawer-popup:opacity-0 group-data-nested-drawer-swiping/drawer-popup:opacity-100", t),
	"data-slot": "drawer-content",
	"data-testid": "drawer-content",
	...r
})), _ = t(({ className: t, render: n, ...r }, o) => {
	let s = {
		className: e("border-border-100 flex w-full shrink-0 flex-col items-start border-b p-4", "transition-opacity duration-300 ease-[cubic-bezier(0.45,1.005,0,1.005)] group-data-nested-drawer-open/drawer-popup:opacity-0 group-data-nested-drawer-swiping/drawer-popup:opacity-100", t),
		"data-slot": "drawer-header",
		"data-testid": "drawer-header",
		ref: o
	};
	return a({
		defaultTagName: "div",
		props: i(s, r),
		render: n
	});
}), v = t(({ className: t, elevated: n = !1, render: r, ...o }, s) => {
	let c = {
		className: e("bg-bg-primary flex w-full shrink-0 items-center justify-center p-4", n ? "shadow-[0_0_15px_rgba(15,23,42,0.05)]" : "border-border-100 border-t", "transition-opacity duration-300 ease-[cubic-bezier(0.45,1.005,0,1.005)] group-data-nested-drawer-open/drawer-popup:opacity-0 group-data-nested-drawer-swiping/drawer-popup:opacity-100", t),
		"data-slot": "drawer-footer",
		"data-testid": "drawer-footer",
		ref: s
	};
	return a({
		defaultTagName: "div",
		props: i(c, o),
		render: r
	});
}), y = t(({ className: t, ...r }, i) => /* @__PURE__ */ n(o.Title, {
	ref: i,
	className: e("text-text-primary text-2xl font-semibold", t),
	"data-slot": "drawer-title",
	"data-testid": "drawer-title",
	...r
})), b = t(({ className: t, ...r }, i) => /* @__PURE__ */ n(o.Description, {
	ref: i,
	className: e("text-text-tertiary text-base", t),
	"data-slot": "drawer-description",
	"data-testid": "drawer-description",
	...r
}));
c.displayName = "Drawer.Root", l.displayName = "Drawer.Portal", u.displayName = "Drawer.Trigger", d.displayName = "Drawer.Close", f.displayName = "Drawer.Backdrop", p.displayName = "Drawer.Viewport", h.displayName = "Drawer.Popup", m.displayName = "Drawer.Handle", g.displayName = "Drawer.Content", _.displayName = "Drawer.Header", v.displayName = "Drawer.Footer", y.displayName = "Drawer.Title", b.displayName = "Drawer.Description";
var x = {
	Root: c,
	Portal: l,
	Trigger: u,
	Close: d,
	Backdrop: f,
	Viewport: p,
	Popup: h,
	Handle: m,
	Content: g,
	Header: _,
	Footer: v,
	Title: y,
	Description: b,
	createHandle: o.createHandle
};
//#endregion
export { x as Drawer };
